export default "__VITE_ASSET__CWmqF1$G__"